import React from "react";

// Banner shown above a stage's partial results when its status is "Not Completed".
const StageNotCompletedNotice = ({ stageLabel, action }) => (
  <div className="cpv2-video__status-card cpv2-video__status-card--warning" style={{ marginBottom: 16, justifyContent: "space-between", flexWrap: "wrap" }}>
    <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <span className="cpv2-video__status-dot cpv2-video__status-dot--yellow" />
      The candidate did not complete the {stageLabel}. Showing the results recorded so far.
    </span>
    {action}
  </div>
);

export default StageNotCompletedNotice;
